import React from 'react';
import styles from './RemainingTokens.module.scss';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const RemainingTokens = ({ botId }) => {
  const { data: remainingTokens } = useFetch(
    ['reminingTokens', botId],
    dashboardEndpoints.getMessagesLeft(),
    { enabled: true },
    botId ? { botId: botId } : {}
  );

  const used = Number(remainingTokens?.data?.used ?? 0);
  const total = Number(remainingTokens?.data?.total ?? 0);
  const remaining = Math.max(total - used, 0);
  const percentUsed = total > 0 ? (used / total) * 100 : 0;
  const isCritical = percentUsed >= 90;

  const formatCompact = (n) =>
    new Intl.NumberFormat('en', {
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(Number(n ?? 0));

  const formatCompactMaybeDecimals = (n) => {
    const num = Number(n ?? 0);
    const hasDecimals = !Number.isInteger(num);
    return new Intl.NumberFormat('en', {
      notation: 'compact',
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(num);
  };

  const remainingClass = [styles.remaining, isCritical ? styles.critical : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={styles['remaining-tokens-container']}>
      <div className={styles.header}>
        <div className={styles.subtitle}>Remaining Tokens</div>
        <div className={styles.valueRow}>
          <span className={remainingClass}>
            {formatCompactMaybeDecimals(remaining)}
          </span>
          <span className={styles.total}>/ {formatCompact(total)}</span>
        </div>
      </div>
      <SvgWithBranding type='lineChart2' className={styles['line-chart']} />
    </div>
  );
};

export default RemainingTokens;
